<div class="badge-container">
  <mat-icon class="mat-icon-position" [matTooltip]="tooltip">{{ iconClass }}</mat-icon>
</div>
